module.exports = __webpack_public_path__ + "static/media/progress.8a3839ba.png";